module.exports = __webpack_public_path__ + "img/rotate-exclamation.0e4c9968.svg";